import { render } from "./WebViewer.vue?vue&type=template&id=144eb135"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"

import "./WebViewer.vue?vue&type=style&index=0&id=144eb135&lang=css"
script.render = render

export default script